<template>
  <div class="header-wrapper" :style="{ background: bgcolor ? bgcolor : '' }">
    <el-row type="flex" class="row-bg" justify="space-between">
      <el-col :span="6">
        <div>
          <div class="header-logo">
            <!-- <el-image
              @click="GotoClassRoom"
              class="header-logo-img"
              src="https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/homepage/classroom.png"
            ></el-image> -->
            <!-- 有教师角色就返回教师，否则返回首页 -->
            <span @click="GotoClassRoom" v-if="$store.state.user.roleList.includes(2)">
              <i class="icon-back"><svg t="1722216424214" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10206" width="28" height="28">
                  <path d="M512 23C241.38 23 22 242.38 22 513s219.38 490 490 490 490-219.38 490-490S782.62 23 512 23z m152.33 689.71c19.44 19.44 19.44 50.97 0 70.41-19.44 19.44-50.97 19.44-70.41 0l-234.7-234.7c-19.44-19.44-19.44-50.97 0-70.41 0.07-0.07 0.15-0.14 0.23-0.22 0.07-0.07 0.14-0.15 0.22-0.23l234.7-234.7c19.44-19.44 50.97-19.44 70.41 0 19.44 19.44 19.44 50.97 0 70.41L464.84 513.22l199.49 199.49z" fill="#ffffff" p-id="10207"></path>
                </svg>
              </i>
              我的教室
            </span>
            <span @click="GotoHome" v-else>
              <i class="icon-back"><svg t="1722216424214" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10206" width="28" height="28">
                  <path d="M512 23C241.38 23 22 242.38 22 513s219.38 490 490 490 490-219.38 490-490S782.62 23 512 23z m152.33 689.71c19.44 19.44 19.44 50.97 0 70.41-19.44 19.44-50.97 19.44-70.41 0l-234.7-234.7c-19.44-19.44-19.44-50.97 0-70.41 0.07-0.07 0.15-0.14 0.23-0.22 0.07-0.07 0.14-0.15 0.22-0.23l234.7-234.7c19.44-19.44 50.97-19.44 70.41 0 19.44 19.44 19.44 50.97 0 70.41L464.84 513.22l199.49 199.49z" fill="#ffffff" p-id="10207"></path>
                </svg>
              </i>
              返回首页
            </span>
          </div>
        </div>
      </el-col>
      <div class="header-title">
        <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" text-color="#ffffff" active-text-color="#fcdb95">
          <el-menu-item index="2" @click="$router.push({ name: 'community-home' })">社区首页</el-menu-item>
          <el-menu-item index="3" @click="$router.push({ name: 'community-explore' })">发现作品</el-menu-item>
          <el-menu-item index="5" v-if="$store.state.user.schoolInfo.zoneShareAuth" @click="$router.push({ name: 'community-shared' })">共创世界</el-menu-item>
        </el-menu>
      </div>
      <el-col :span="6">
        <div class="header-state">
          <el-row>
            <el-col :span="8" :offset="10">
              <div style="text-align: right;white-space: nowrap;">
                <span style="line-height: 60px; color: white; font-size: 16px" @click="drawer = true">欢迎 ,
                </span>
                <span style="
                    line-height: 40px;
                    color: white;
                    font-size: 16px;
                    font-weight: bold;
                  " v-if="$store.state.user.identity === 2" class="username">{{ $store.state.user.userInfo.stuUserInfo.realName }}</span>

                <el-tooltip v-else class="item" effect="dark" :content="$store.state.user.userInfo.realName" placement="bottom">
                  <span style="
                      max-width:64px;line-height: 60px;color: white;font-size: 16px;font-weight: bold; display: inline-block;white-space: nowrap;overflow: hidden;vertical-align: top;text-overflow: ellipsis;
                    " class="username">{{ $store.state.user.userInfo.realName }}</span>
                </el-tooltip>
              </div>
            </el-col>

            <el-col :span="6">
              <div>
                <el-dropdown>
                  <el-avatar style="margin-top: 12px; border: 1px solid white" size="medium" :src="
                      $store.state.user.userInfo.userImageUrl
                        ? $store.state.user.userInfo.userImageUrl
                        : $store.state.user.userInfo.headimgUrl
                    "></el-avatar>

                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="classroom_show">
                      <router-link :to="{ name: 'classroomIndex' }" tag="li">我的教室</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="classroomstu_show">
                      <router-link :to="{ name: 'code-classroom-stu' }" tag="li">我的教室</router-link>
                    </el-dropdown-item>

                    <el-dropdown-item v-if="community_show">
                      <router-link :to="{ name: 'community-home' }" tag="li">作品社区</router-link>
                    </el-dropdown-item>

                    <el-dropdown-item v-if="schoolanagement_show">
                      <span @click="GotoSchool" tag="li">校区管理</span>
                    </el-dropdown-item>

                    <el-dropdown-item divided>
                      <userinfo></userinfo>
                    </el-dropdown-item>

                    <el-dropdown-item>
                      <passward></passward>
                    </el-dropdown-item>

                    <el-dropdown-item divided @click.native="layout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import userinfo from '@/components/userinfo'
import passward from '@/components/passward'
export default {
  name: 'community-header',
  props: {
    bgcolor: String,
  },
  data() {
    return {
      is_principal: false, //超级管理员
      header_show: false,
      home_show: false,
      classroom_show: false, //我的教室
      classroomstu_show: false, //学生我的教室
      preparelesson_show: false, //备课中心
      community_show: false, //编程社区
      schoolanagement_show: false, //学校管理
      props: { multiple: true },
      school_list: [], //校区列表
      Select_School: [], //所选校区
      show_school: false,
      school_logo: '',
    }
  },

  components: { userinfo, passward },
  mounted() {
    const roleList = this.$store.getters.roleList
    const is_principal = this.$store.getters.is_principal

    if (is_principal) {
      this.header_show = true
      this.home_show = true
      this.classroom_show = true
      this.preparelesson_show = true //备课中心
      this.community_show = true //编程社区
      this.schoolanagement_show = true //学校管理

      for (let i = 0; i < roleList.length; i++) {
        if (roleList[i] === 2) {
          //'教师'
          this.classroom_show = true
        }
      }
    } else {
      if (roleList) {
        for (let i = 0; i < roleList.length; i++) {
          if (roleList[i] === 5) {
            // 管理员
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
          } else if (roleList[i] === 1) {
            //校长
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
          } else if (roleList[i] === 2) {
            //'教师'
            this.header_show = true
            this.home_show = true
            this.classroom_show = true
            this.preparelesson_show = true
            this.community_show = true
            this.schoolanagement_show = true
          } else if (roleList[i] === 3) {
            //教务
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
            console.log('教务')
          } else if (roleList[i] === 4) {
            //销售
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
            console.log('销售')
          } else if (roleList[i] === '财务') {
            this.header_show = true
            this.home_show = true
            console.log('财务')
            this.schoolanagement_show = true
          } else if (roleList[i] === 6) {
            //前台
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
            console.log('前台')
          }
        }
      } else {
        this.header_show = true
        this.home_show = true
        console.log('学生')
        this.classroomstu_show = true
        this.community_show = true
      }
    }
  },

  activated() {
    console.log('当前路径')
    console.log(this.$route.path)
  },

  computed: {
    activeIndex: function () {
      if (this.$route.path == '/community/home') {
        return '2'
      } else if (this.$route.path == '/community/explore') {
        return '3'
      } else if (this.$route.path == '/community/shared') {
        return '5'
      } else return ''
    },
  },

  methods: {
    GotoSchool() {
      console.log('当前客户权限表-标题栏')
      console.log(this.$store.getters.permisionList)

      let name
      if (this.$store.getters.permisionList.length > 0) {
        if (this.$store.getters.permisionList[0].children.length > 0) {
          name = this.$store.getters.permisionList[0].children[0].alias.split(
            ','
          )[0]
        } else {
          name = this.$store.getters.permisionList[1].children[0].alias.split(
            ','
          )[0]
        }
      }

      this.$router.push({
        name: name,
      })
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      this.activeIndex = key
    },

    chooseTools(cmd) {
      console.log(cmd)
      if (cmd == 'jrcode') {
        window.open('/jrcode/index.html')
      } else if (cmd == 'scratch') {
        window.open('/scratch/index.html')
      } else if (cmd == 'python') {
        window.open('/python/index.html')
      }
    },
    //退出登陆
    layout() {
      this.$store.dispatch('LogOut').then(() => {
        sessionStorage.setItem('schoolInfo', null)
        localStorage.removeItem('editor_opentype')
        this.$message.success('退出成功')
        this.$router.push({ path: '/' })
        location.reload()
      })
    },
    //返回首页
    GotoHome() {
      this.$router.push({ name: 'home' })
    },
    //返回教室
    GotoClassRoom() {
      if (this.$store.state.user.identity == '2') {
        this.$router.push({ name: 'classroomIndexStu' })
      } else {
        this.$router.push({ name: 'classroomIndex' })
      }
    },
  },
}
</script>

<style>
.header-title .el-menu.el-menu--horizontal {
  border-bottom: 0;
  background-color: transparent;
}

.header-title .el-menu--horizontal > .el-menu-item.is-active {
  border: 0;
}

.header-title .el-menu--horizontal > .el-menu-item {
  border: 0;
}

.header-title .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.header-title .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.header-title .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: rgba(75, 75, 75, 0.466);
}
</style>

<style scoped lang="scss">
.tools {
  text-align: center;
}

.header-wrapper {
  position: absolute;
  width: 100%;
  height: 60px;
  top: 0px;
  color: white;
  z-index: 10;

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .header-logo {
    display: flex;
    width: 155px;
    height: 60px;
    overflow: hidden;

    margin-top: 5px;
    margin-left: 20px;
    cursor: pointer;

    .header-logo-img {
      width: 100%;
    }
    span {
      display: inline-flex;
      align-items: center;
      padding-left: 10px;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      i {
        display: inline-flex;
        align-items: center;
        margin-right: 8px;
      }
    }
  }

  .header-title {
    text-align: center;
    font-weight: bold;
  }

  .header-state {
    text-align: center;
    height: 60px;
  }
  /deep/ .el-avatar img {
    width: 100%;
  }
}
</style>
